import { render, staticRenderFns } from "./UlModalSpecialDay.vue?vue&type=template&id=2350cc20&"
import script from "./UlModalSpecialDay.vue?vue&type=script&lang=ts&"
export * from "./UlModalSpecialDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports